import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  title: 'Apply to All Devices?',
  description:
    'Would you like to apply these changes to all devices currently assigned to this site?',
  primaryButtonLabel: 'Apply to All Devices',
  secondaryButtonLabel: 'Just this Device',
})
